<ng-container *sm-has-env-flag="'auroraV1'">
    <aurora-icon-button
        id="notificationsButton"
        class="main-menu-button"
        variant="ghost"
        size="xlarge"
        icon="bell"
        label="Notifications"
        [badgeCount]="getUnreadNotificationsCount()"
    >
    </aurora-icon-button>

    <aurora-popover
        #notifyPopover
        class="notifications-popover-aurora"
        aurora-light
        position="bottom left"
        [showCloseButton]="false"
        (toggle)="onNotificationsPopoverToggle($event)">
        <div class="notifications-popover-content-aurora">
            <sm-global-notifications
                aurora-light
                [settings]="notificationCenter"
                [notificationCards]="notificationCardVMs"
                (onClickLink)="onClickLink($event)"
                (onClose)="handleReadNotifications($event)"
            />
        </div>
    </aurora-popover>
</ng-container>

<ng-container *sm-has-not-env-flag="'auroraV1'">
    <button
        unity-button
        id="notificationsButton"
        class="main-menu-button xlarge icon-only on_dark"
        [ngbPopover]="notifications"
        placement="bottom-right"
        popoverClass="notifications-popover-unity"
        #notifyPopoverLegacy="ngbPopover"
        [autoClose]="'outside'"
        (hidden)="handleDeletedNotifications()"
        [badgeCount]="getUnreadNotificationsCount()"
    >
        <unity-icon icon="bell" size="xlarge" />
    </button>

    <ng-template #notifications>
        <sm-global-notifications
            [settings]="notificationCenter"
            [notificationCards]="notificationCardVMs"
            (onClickLink)="onClickLink($event)"
            (onClose)="handleReadNotifications($event)"
        />
    </ng-template>
</ng-container>
